export const SKETCH_HOST_ID = "$$prototype-host";
export const META_ROOT_ID = "$$meta-root";
